import { Layout } from '@components'
import Panel from '@components/Panel'
import { when } from '@core'
import { Show, createSignal } from 'solid-js'
import { css } from 'styled-system/css'
import { Box, Grid } from 'styled-system/jsx'
import Channels from '../Chat/Channels'
import Column from './Column'
import LatestRecordings from './LatestRecordings'
import NextEvents from './NextEvents'
import Setups from './Setups'
import { Filter } from './Setups/Filter'
import TradeLeaders from './TradeLeaders'

const Desktop = () => (
  <Panel
    gap={3}
    p={3}
    display='grid'
    position="relative"
    gridTemplateColumns="auto 1fr auto"
    pb={0}
  >
    <Column
      title="Trade Leaders"
      link="/chat/trade-leaders"
    >
      <Box minWidth='350px'>
        <TradeLeaders height='calc(var(--vh) * 100 - 140px)' />
      </Box>
    </Column>
    <Column
      title="Setups"
      link="/setups"
      rightSlot={<Filter />}
    >
      <Setups />
    </Column>
    <Grid alignContent="start">
      <Column
        title="Chats"
        link="/chat"
      >
        <Box p="3" overflow='auto' height='calc(var(--vh) * 100 - 553px)'
          overflowY='auto' class='scrollbar'>
          <Channels
            isMinimal
            height="auto"
          />
        </Box>
      </Column>
      <Column title="Events" link="/events">
        <NextEvents />
      </Column>
      <Column title="Latest Recordings" link="/recordings">
        <LatestRecordings />
      </Column>
    </Grid>
  </Panel >
)

const Mobile = () => {
  // NEW: Track the currently open column. Initialize with an ID or null.
  const [activeCol, setActiveCol] = createSignal<string | null>('trade-leaders')

  // NEW: Helper to safely handle open changes.
  // (Note: Depending on your UI library, 'e' might be a boolean or an object like { open: boolean })
  const handleOpenChange = (id: string, e: any) => {
    const isOpen = typeof e === 'boolean' ? e : e.open
    setActiveCol(isOpen ? id : null)
  }

  return (
    <Panel display='grid' gap={3} p={3} alignContent='start'>
      <Column
        isCollapsible
        open={activeCol() === 'trade-leaders'}
        onOpenChange={(e: any) => handleOpenChange('trade-leaders', e)}
        title="Trade Leaders"
        link="/chat/trade-leaders"
      >
        <TradeLeaders height='auto' />
      </Column>
      <Column
        isCollapsible
        open={activeCol() === 'chats'}
        onOpenChange={(e: any) => handleOpenChange('chats', e)}
        title="Chats"
        link="/chat"
      >
        <Box p="3">
          <Channels isMinimal height="auto" />
        </Box>
      </Column>
      <Column
        isCollapsible
        open={activeCol() === 'events'}
        onOpenChange={(e: any) => handleOpenChange('events', e)}
        title="Events"
        link="/events"
      >
        <NextEvents />
      </Column>
      <Column
        isCollapsible
        open={activeCol() === 'recordings'}
        onOpenChange={(e: any) => handleOpenChange('recordings', e)}
        title="Latest Recordings"
        link="/recordings"
      >
        <LatestRecordings />
      </Column>
    </Panel>
  )
}

export default function () {

  return (
    <Show
      when={when.mdDown()}
      fallback={<Desktop />}
    >
      <Mobile />
    </Show>
  )
}

// {/* <TradeLeaders />
// <Setups />
// <Chats /> */}
// {/* <Flex
// 	justifyContent="space-between"
// 	gap={4}
// 	alignItems={{ base: 'center', smDown: 'stretch' }}
// 	flexDirection={{ base: 'row', smDown: 'column' }}
// >
// 	<Welcome />
// 	<FranicsUpdates username="fred" />
// </Flex>
// <Grid
// 	height={{
// 		base: 'calc(100vh - 246px)',
// 		mdDown: 'auto',
// 	}}
// 	gridTemplateColumns={{
// 		base: '1fr 1fr',
// 		mdDown: '1fr',
// 	}}
// >
// 	<Show
// 		when={isOnboarded()}
// 		fallback={<Onboarding />}
// 	>
// 		<Setups />
// 		<Chats />
// 	</Show>
// </Grid> */}
